<template lang="html">


    <!-- Sidebar -->
    <div class="border-right" id="sidebar-wrapper">
      <div class="header-sidebar" slot="header">
          <img :src="basepath+'/unodc_logo.png'" alt="" width="200" />
      </div>
      <div class="list-group list-group-flush">
          <router-link to="/dashboard/communicationOfficer/home" class="list-group-item list-group-item-action bg-light">
            <i class="material-icons">home</i> Home
          </router-link>
          
        <router-link to="/dashboard/communicationOfficer/material" class="list-group-item list-group-item-action bg-light">
          <i class="material-icons">folder</i> Material Archive
        </router-link>

       </div>
    </div>
</template>

<script>
import { bus } from "../../../main";
export default {
  data: () => ({
    active: true,
    basepath: localStorage.getItem("BASE_PATH")
  }),
  created() {
    bus.$on("sidebarStatus", data => {
      this.active = data;
    });
  },
  methods: {
    isSidebar() {
      bus.$emit("sidebarStatus", this.active);
    }
  }
};
</script>
<style>
/* .list-group-item:hover {
  padding-left: 30px;
  transition: 0.5s ease;
} */
</style>

<style scoped>

body {
  overflow-x: hidden;
}

.material-icons {
  font-size: 20px !important;
  vertical-align: bottom;
}
#sidebar-wrapper {
  min-height: 100vh;
  margin-left: -15rem;
  -webkit-transition: margin 0.25s ease-out;
  -moz-transition: margin 0.25s ease-out;
  -o-transition: margin 0.25s ease-out;
  transition: margin 0.25s ease-out;
}

#sidebar-wrapper .sidebar-heading {
  padding: 0.875rem 1.25rem;
  font-size: 1.2rem;
}

#sidebar-wrapper .list-group {
  width: 15rem;
}

#page-content-wrapper {
  min-width: 100vw;
}

#wrapper.toggled #sidebar-wrapper {
  margin-left: 0;
}

@media (min-width: 768px) {
  #sidebar-wrapper {
    margin-left: 0;
  }

  #page-content-wrapper {
    min-width: 0;
    width: 100%;
  }

  #wrapper.toggled #sidebar-wrapper {
    margin-left: -15rem;
  }
}
/* scrollbar css starts */
/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
  /* -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3); */
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: rgba(7, 167, 225);
  border-radius: 50px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: rgba(7, 167, 225);
}
/* scrollbar css ends */
</style>